<template>
  <span style="cursor: pointer" @click="openModal()" v-if="subscription">{{
    subscription.orderId
  }}</span>

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId" v-if="active">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">아이디 상세정보</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" style="padding: 10px 0px 0px 0px !important">
          <h5>상품정보</h5>
          <table class="table" style="font-size: 13px">
            <tbody>
              <tr>
                <th width="15%">학습유형</th>
                <td width="25%"><template v-if="Tsub.prodType == 'ChildUM'">ChildU(M)</template><template v-else>{{ Tsub.prodType }}</template></td>
                <th width="15%">학습레벨</th>
                <td width="25%">{{ Tsub.level }}</td>
              </tr>
              <tr>
                <th>상품명</th>
                <td>{{ Tsub.product }}</td>
                <th>학생</th>
                <td>
                  {{ student ? student.name : "" }}
                  <template v-if="this.$root.guiPerm == 'ROOT'"
                    ><br />
                    <template v-if="lastEnd"
                      >상태:

                      <span v-if="lastEnd.status == 'WAITING_PAYMENT'"
                        >결제 대기 중</span
                      >
                      <span v-if="lastEnd.status == 'PAYMENT_LATE'"
                        >결제 만료</span
                      >
                      <span v-if="lastEnd.status == 'ACTIVE'">사용 중</span>
                      <span v-if="lastEnd.status == 'PENDING'"
                        >대행 대기 중</span
                      >
                      <span v-if="lastEnd.status == 'ENDED'">정상 종료</span>
                      <span v-if="lastEnd.status == 'CANCELLED'">취소됨</span>
                      <span v-if="lastEnd.status == 'RESERVED'">연장</span>
                      <span v-if="lastEnd.status == 'CONFIRMING_PAYMENT'"
                        >결제 확인 중</span
                      >
                      <span v-if="lastEnd.status == 'CANCEL_PENDING'"
                        >취소승인 대기 중</span
                      >
                      <br />종료일: {{ lastEnd.endDate }}</template
                    >
                    <template v-else
                      ><a href="#" @click.prevent="getLastEnd()"
                        ><span
                          class="btn btn-success btn-sm"
                          style="padding: 2px 4px"
                          >최종 종료일 확인</span
                        ></a
                      ></template
                    >
                  </template>
                </td>
              </tr>
              <tr>
                <th>기간</th>
                <td>{{ Tsub.period }}개월</td>
                <th>금액</th>
                <td>{{ Tsub.price }}</td>
              </tr>
              <tr>
                <th>ID</th>
                <td>
                  <input
                    type="text"
                    class="hidtype"
                    v-model="Tsub.assignId"
                    :disabled="
                      Tsub.status != 'WAITING_PAYMENT' &&
                      Tsub.status != 'PAYMENT_LATE' &&
                      Tsub.status != 'PENDING' &&
                      Tsub.status != 'CONFIRMING_PAYMENT'
                    " 
                  /><br />
                  <template v-if="this.$root.guiPerm == 'ROOT' && student"
                    >학교ID:
                    <select
                      class="hidtype"
                      :disabled="
                        Tsub.status != 'WAITING_PAYMENT' &&
                        Tsub.status != 'PAYMENT_LATE' &&
                        Tsub.status != 'PENDING' &&
                        Tsub.status != 'CONFIRMING_PAYMENT'
                      "
                      v-model="student.school_id"
                    >
                      <option value="MyPath">MyPath</option>
                      <option value="kchild408" selected>kchild408</option>
                      <option value="kchild139">kchild139</option>
                      <option value="Edgchildu">Edgchildu</option>
                    </select>
                  </template>
                </td>
                <th>북클럽</th>
                <td>{{ Tsub.prodBookclubs ? "사용" : "미사용" }}</td>
              </tr>
              <tr>
                <th>보카조아</th>
                <td>{{ Tsub.prodVocajoa ? "사용" : "미사용" }}</td>
                <th>주문상태</th>
                <td>
                  <span v-if="Tsub.status == 'WAITING_PAYMENT'"
                    >결제 대기 중</span
                  >
                  <span v-if="Tsub.status == 'PAYMENT_LATE'">결제 만료</span>
                  <span v-if="Tsub.status == 'ACTIVE'">사용 중</span>
                  <span v-if="Tsub.status == 'PENDING'">대행 대기 중</span>
                  <span v-if="Tsub.status == 'ENDED'">정상 종료</span>
                  <span v-if="Tsub.status == 'CANCELLED'"
                    >취소됨<br />{{ Tsub.cancel_request_date }}</span
                  >
                  <span v-if="Tsub.status == 'RESERVED'">연장</span>
                  <span v-if="Tsub.status == 'CONFIRMING_PAYMENT'"
                    >결제 확인 중</span
                  >
                  <span v-if="Tsub.status == 'CANCEL_PENDING'"
                    >취소승인 대기 중<br />{{ Tsub.cancel_request_date }}</span
                  >
                </td>
              </tr>
              <template v-if="Tsub.prodType == 'ChildUM'">
              <tr>
                <th>학습과목 </th>                
                <td colspan="3" style='text-align: left;padding-left: 30px;'>
                  <input type="checkbox" v-model="LA" :disabled="Tsub.status !== 'WAITING_PAYMENT' &&
                  Tsub.status !== 'PAYMENT_LATE' &&
                  Tsub.status !== 'PENDING'  &&
                  Tsub.status !== 'CONFIRMING_PAYMENT' "/> Language Arts
                  <input type="checkbox" v-model="MA" :disabled="Tsub.status !== 'WAITING_PAYMENT' &&
                  Tsub.status !== 'PAYMENT_LATE' &&
                  Tsub.status !== 'PENDING' &&
                  Tsub.status !== 'CONFIRMING_PAYMENT'"/>Math 
                  <input type="checkbox" v-model="SC" :disabled="Tsub.status !== 'WAITING_PAYMENT' &&
                  Tsub.status !== 'PAYMENT_LATE' &&
                  Tsub.status !== 'PENDING' &&
                  Tsub.status !== 'CONFIRMING_PAYMENT'"> Science 
                  <input type="checkbox" v-model="SS" :disabled="Tsub.status !== 'WAITING_PAYMENT' &&
                  Tsub.status !== 'PAYMENT_LATE' &&
                  Tsub.status !== 'PENDING' &&
                  Tsub.status !== 'CONFIRMING_PAYMENT'"/>Social Studies    
                  
                <button v-if="
                this.$root.guiPerm == 'ROOT' &&
                (Tsub.status === 'WAITING_PAYMENT' ||
                  Tsub.status === 'PAYMENT_LATE' ||
                  Tsub.status === 'PENDING' ||
                  Tsub.status === 'CONFIRMING_PAYMENT')
              "
              class="btn btn-danger"  @click="subjectChng(Tsub.id)">변경하기</button>           
            </td>          
              </tr>
            </template>
            </tbody>
          </table>
          <h5>결제정보</h5>
          <table class="table" style="font-size: 13px">
            <tbody>
              <tr>
                <th width="15%">시작일</th>
                <td width="25%">
                  {{ Tsub.startDate
                  }}<button
                    class="btn btn-primary btn-sm"
                    style="font-size: 6px; padding: 2px 4px"
                    v-on:click="set_start_date()"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    <i class="bi bi-pencil-fill"></i>
                  </button>
                </td>
                <th width="15%">종료일</th>
                <td width="25%">
                  {{ Tsub.endDate
                  }}<button
                    class="btn btn-primary btn-sm"
                    style="font-size: 6px; padding: 2px 4px"
                    v-on:click="set_end_date()"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    <i class="bi bi-pencil-fill"></i>
                  </button>
                </td>
              </tr>
              <tr>
                <th>결제일</th>
                <td>
                  {{ Tsub.payAt
                  }}<button
                    class="btn btn-primary btn-sm"
                    style="font-size: 6px; padding: 2px 4px"
                    v-on:click="set_pay_date()"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    <i class="bi bi-pencil-fill"></i>
                  </button>
                </td>
                <th>결제금액</th>
                <td>{{ Tsub.price }}</td>
              </tr>
              <tr>
                <th>승인번호</th>
                <td>
                  <input
                    type="text"
                    class="hidtype"
                    style="width: 140px"
                    v-model="Tsub.transactionId"
                    :disabled="
                      Tsub.status != 'WAITING_PAYMENT' &&
                      Tsub.status != 'PAYMENT_LATE'
                    "
                  />
                </td>
                <th>결제방법</th>
                <td>
                  <template v-if="Tsub.paymentMethod == 'CARD_ONPG'"
                    >카드결제(온)</template
                  >
                  <template v-if="Tsub.paymentMethod == 'CARD_OFFPG'"
                    >카드결제(오프)</template
                  >
                  <template v-if="Tsub.paymentMethod == 'CASH'"
                    >무통장입금</template
                  >
                </td>
              </tr>
            </tbody>
          </table>

          <div class="modal-footer">
            <!--button type="button" class="btn btn-warning">온라인->단말기결제 변경</button-->
            <button
              class="btn btn-danger"
              v-on:click="cancel(Tsub.id)"
              v-if="
                Tsub.status == 'WAITING_PAYMENT' ||
                Tsub.status == 'PAYMENT_LATE' ||
                this.$root.guiPerm == 'ROOT'
              "
            >
              취소
            </button>
            <button
              class="btn btn-danger"
              v-on:click="cancel_request(Tsub.id, Tsub.endDate)"
              v-if="
                this.$root.guiPerm !== 'ROOT' &&
                Tsub.status !== 'WAITING_PAYMENT' &&
                Tsub.status !== 'CANCEL_PENDING' &&
                Tsub.status !== 'PAYMENT_LATE'
              "
            >
              취소요청
            </button>

            <button
              class="btn btn-info"
              v-if="
                this.$root.guiPerm == 'ROOT' &&
                (Tsub.status === 'WAITING_PAYMENT' ||
                  Tsub.status === 'PAYMENT_LATE' ||
                  Tsub.status === 'PENDING' ||
                  Tsub.status === 'CONFIRMING_PAYMENT')
              "
              v-on:click="setup(Tsub)"
            >
              대행
            </button>
            <button
              class="btn btn-secondary"
              v-if="
                this.$root.guiPerm == 'ROOT' &&
                Tsub.status === 'WAITING_PAYMENT' &&
                Tsub.paymentMethod === 'CASH'
              "
              v-on:click="setready(Tsub)"
            >
              대행대기
            </button>
            <button
              class="btn btn-info"
              v-if="this.$root.guiPerm == 'ROOT' && Tsub.status === 'ACTIVE'"
              v-on:click="setEnded(Tsub)"
            >
              만료처리
            </button>
            <create-subscription
              v-if="
                student && Tsub.eligible_to_extend && !Tsub.is_extra_service
              "
              :student="student"
              :subscription="Tsub"
              #default="m"
            >
              <button class="btn btn-info" @click="m.click()">즉시연장</button>
            </create-subscription>
            <button
              class="btn btn-primary"
              v-on:click="openPayModal()"
              v-if="
                Tsub.status == 'WAITING_PAYMENT' &&
                Tsub.paymentMethod == 'CARD_ONPG' &&
                (!Tsub.is_extra_service || Tsub.is_after_add)
              "
            >
              URL
            </button>
            <button
              class="btn btn-primary"
              v-on:click="chgToOffline(Tsub)"
              v-if="
                (Tsub.status == 'WAITING_PAYMENT' ||
                  Tsub.status == 'PAYMENT_LATE') &&
                (!Tsub.is_extra_service || Tsub.is_after_add)
              "
            >
              오프라인 카드
            </button>
            <button
              class="btn btn-info"
              v-if="this.$root.guiPerm == 'ROOT'"
              v-on:click="deleteEntire(Tsub)"
            >
              삭제
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    tabindex="-1"
    :id="'payModal' + TbtnId"
    data-bs-backdrop="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">결제정보 보내기</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" style="text-align: center; line-height: 24px">
          <!--span class="btn-danger" style="padding:1px 4px 4px 4px; border-radius:4px;">Tip!</span>
          <p style="margin-top:10px;">
            결제 링크를 보내지 않고도, <span style="font-weight:bold; color:#d05f7a;">신용카드(온라인) 일 경우 학생이 MyPathKR.com 홈페이지에서 직접
              결제</span>할 수도 있습니다.</p-->
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="URL"
              readonly
              v-model="payUrl"
              style="width: 100%"
            />
            <button
              class="btn btn-info btn-sm"
              type="button"
              v-on:click="copyClipboard()"
            >
              <i class="bi bi-clipboard"></i>URL복사
            </button>
          </div>
          <IMS
            title="[차일드유] 컨텐츠비 결제 안내"
            :text="'[차일드유] 컨텐츠비 결제 부탁드립니다. ' + payUrl"
            service="pay"
            v-if="payUrl"
            :phone="Tsub.phone"
            :targetStudent="Tsub.studentId"
            :reqRef="Tsub.id"
            :p_bizId="Tsub.p_biz.id"
            :studentId="Tsub.studentId"
          />
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IMS from "../IMS";
import Student from "./Student";
import CreateSubscription from "../CreateSubscription.vue";

export default {
  name: "Subscription",
  components: {
    IMS,
    CreateSubscription,
    Student,
  },
  methods: {
    openModal() {
      this.active = true;
      this.getDetailSubscription(this.Tsub);
      this.$nextTick(function () {
        var modalDom = document.getElementById("Modal" + this.TbtnId);
        var modal = bootstrap.Modal.getOrCreateInstance(modalDom);
        modalDom.addEventListener("hidden.bs.modal", function (event) {
          this.active = false;
          if (this.reload_once_closed) {
            this.reload_once_closed = false;
            this.$parent.search();
          }
        });
        modal.show();
      });
    },
    openPayModal() {
      this.pay_active = true;
      this.getPayUrl(this.Tsub.id);
      this.$nextTick(function () {
        var modalDom = document.getElementById("payModal" + this.TbtnId);
        var modal = bootstrap.Modal.getOrCreateInstance(modalDom);
        modalDom.addEventListener("hidden.bs.modal", function (event) {
          this.pay_active = false;
        });
        modal.show();
      });
    },
    setup(record) {
      //console.log(record);
      axios
        .patch("/subscriptions/" + record.id, {
          usid: record.assignId,
          school_id: this.student.school_id,
          state: "ACTIVE",
        })
        .then(function (response) {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "처리할 수 없습니다 " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
            if (response.data.refresh_required) {
              this.getDetailSubscription(this.Tsub);
              this.reload_once_closed = true;
            }
          } else {
            console.log(response.data.data);
            $.notify(
              {
                // options
                message: "대행에 성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.reload_once_closed = true;
          }
        });
    },
   //과목변경신청
   subjectChng(id) {
        var subject_arr_update = "";
        var cnt = 0;
        if(this.LA === true){
          subject_arr_update = "LA,";
          cnt++;
        } 
        if(this.MA === true){
          subject_arr_update = subject_arr_update + "MA,";
          cnt++;
        }
        if(this.SC === true){
          subject_arr_update = subject_arr_update + "SC,";
          cnt++;
        }
        if(this.SS === true){
          subject_arr_update = subject_arr_update + "SS,";
          cnt++;
        }
        console.log("subject_arr_update:"+subject_arr_update);
        //console.log("cnt:"+parseInt(cnt));
        //console.log("subject_cnt:"+parseInt(this.Tsub.subject));
        console.log("id:"+id);
        
        if(parseInt(cnt) !== parseInt(this.Tsub.subject)){
          alert('선택할 수 있는 과목수가 다릅니다. 확인해주세요.\n(선택 가능한 과목수: '+this.Tsub.subject+'개)');
          return;
        }

       // return;

        
        axios.patch('/subscriptions/' + id + '/subject', {
          "subject_arr": subject_arr_update
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '변경이 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '변경이 완료되었습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.reload_once_closed = true;

          }


        })
        
      },
    setready(record) {
      //console.log(record);
      axios
        .patch("/subscriptions/" + record.id, {
          usid: record.assignId,
          school_id: this.student.school_id,
          state: "READY",
        })
        .then(function (response) {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "처리할 수 없습니다 " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
            if (response.data.refresh_required) {
              this.getDetailSubscription(this.Tsub);
              this.reload_once_closed = true;
            }
          } else {
            //console.log(response.data.data);
            $.notify(
              {
                // options
                message: "대행대기에 성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.reload_once_closed = true;
          }
        });
    },
    setEnded(record) {
      if (new Date(record.endDate) > new Date()) {
        if (
          !confirm(
            "아직 만료일이 지나지 않은 아이디입니다. 다시한번 확인해주시기 바랍니다."
          )
        )
          return;
      }
      //console.log(record);
      axios
        .patch("/subscriptions/" + record.id, {
          state: "ENDED",
        })
        .then(function (response) {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
            if (response.data.refresh_required) {
              this.reload_once_closed = true;
              this.getDetailSubscription(this.Tsub);
            }
          } else {
            //console.log(response.data.data);
            $.notify(
              {
                // options
                message: "성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.reload_once_closed = true;
          }
        });
    },
    deleteEntire(record) {
      if (!confirm("정말로 삭제할까요?")) return;
      //console.log(record);
      axios
        .delete("/subscriptions/" + record.id + "/entire")
        .then(function (response) {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            //console.log(response.data.data);
            $.notify(
              {
                // options
                message: "성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.reload_once_closed = true;
          }
        });
    },
    getDetailSubscription(subscription) {
      axios.get("/subscriptions/" + subscription.id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.Tsub = response.data.result;
          //console.log("this.Tsub:"+JSON.stringify(this.Tsub));
          this.LA = false;
            this.MA = false;
            this.SC = false;
            this.SS = false;
            
            if(this.Tsub.study_subject.indexOf('LA') !== -1){
            this.LA = true;
            }
            if(this.Tsub.study_subject.indexOf('MA') !== -1){
              this.MA = true;
            }
            if(this.Tsub.study_subject.indexOf('SC') !== -1){
              this.SC = true;
            }
            if(this.Tsub.study_subject.indexOf('SS') !== -1){
              this.SS = true;            }
        }
           

      });

      axios.get("/students/" + this.Tsub.studentId).then((response) => {
        this.student = response.data.result;
       // console.log(" this.student:"+JSON.stringify(this.Tsub));
        
      });
            


    },
    cancel(id) {
      var now_utc = Date.now(); // 지금 날짜를 밀리초로
      // getTimezoneOffset()은 현재 시간과의 차이를 분 단위로 반환
      var timeOff = new Date().getTimezoneOffset() * 60000; // 분단위를 밀리초로 변환
      // new Date(now_utc-timeOff).toISOString()은 '2022-05-11T18:09:38.134Z'를 반환
      var today = new Date(now_utc - timeOff).toISOString().split("T")[0];

      if (today) {
      }
      if (confirm("주문 상품을 취소하시겠습니까?")) {
        axios.delete("/subscriptions/" + id).then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "취소에 실패하였습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "취소에 성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.getDetailSubscription(this.Tsub);
            this.reload_once_closed = true;
          }
        });
      }
    },
    cancel_request(id, edate) {
      if (edate) {
        var now_utc = Date.now(); // 지금 날짜를 밀리초로
        // getTimezoneOffset()은 현재 시간과의 차이를 분 단위로 반환
        var timeOff = new Date().getTimezoneOffset() * 60000; // 분단위를 밀리초로 변환
        // new Date(now_utc-timeOff).toISOString()은 '2022-05-11T18:09:38.134Z'를 반환
        var today = new Date(now_utc - timeOff).toISOString().split(".")[0];
        console.log(today);
        console.log(edate);
        if (today > edate) {
          $.notify(
            {
              // options
              message: "종료일이 지난 상품은 취소요청을 하실 수 없습니다.",
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          if (confirm("주문 상품을 취소하시겠습니까?")) {
            axios.delete("/subscriptions/" + id).then((response) => {
              if (response.data.error) {
                $.notify(
                  {
                    // options
                    message: "취소에 실패하였습니다. " + response.data.error,
                  },
                  {
                    // settings
                    type: "danger",
                    z_index: 9999,
                  }
                );
              } else {
                $.notify(
                  {
                    // options
                    message: "취소에 성공하였습니다.",
                  },
                  {
                    // settings
                    type: "success",
                    z_index: 9999,
                  }
                );
                this.getDetailSubscription(this.Tsub);
                this.reload_once_closed = true;
              }
            });
          }
        }
      } else {
        if (confirm("주문 상품을 취소하시겠습니까?")) {
          axios.delete("/subscriptions/" + id).then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message: "취소에 실패하였습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              $.notify(
                {
                  // options
                  message: "취소에 성공하였습니다.",
                },
                {
                  // settings
                  type: "success",
                  z_index: 9999,
                }
              );
              this.getDetailSubscription(this.Tsub);
              this.reload_once_closed = true;
            }
          });
        }
      }
    },
    getLastEnd() {
      axios.get("/students/" + this.Tsub.studentId).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          if (response.data.result) {
            this.lastEnd = response.data.result;
          } else {
            $.notify(
              {
                // options
                message: "학생 정보가 올바르지 않습니다.",
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          }
        }
      });
    },
    getPayUrl(id) {
      this.getDetailSubscription({
        id: id,
      });
      this.payUrl = "";
      axios.get("/subscriptions/" + id + "/payments/url").then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.payUrl = this.$root.baseUrl + response.data.url;
        }
      });
    },
    chgToOffline() {
      axios
        .patch("/subscriptions/" + this.Tsub.id, {
          state: "CONFIRMING_PAYMENT",
          ref: this.Tsub.transactionId,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "변경실패: " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.reload_once_closed = true;
            $.notify(
              {
                // options
                message: "변경되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
          }
        });
    },
    copyClipboard() {
      navigator.clipboard.writeText(this.payUrl);
      $.notify(
        {
          // options
          message: "클립보드에 결제링크가 복사되었습니다",
        },
        {
          // settings
          type: "success",
          z_index: 9999,
        }
      );
    },
    quickExtend() {
      // 기존 상품의 데이터를 토대로 새로운 주문을 넣기
      axios
        .post("/subscriptions", {
          hopeStart: this.Tsub.endDate,
          level: this.Tsub.level,
          paymentMethod: "CARD_ONPG",
          product: this.Tsub.prodCode,
          student: this.Tsub.studentId,
          previous_order: this.Tsub.id,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "연장 실패하였습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "연장신청 성공하였습니다. ",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.moreStudentInfo(this.selData);
          }
        });
    },
    set_start_date() {
      var record = this.Tsub;
      var new_end_date = prompt("새 시작일을 입력하세요. 예: 2022-04-05");
      if (!new_end_date) return;
      axios
        .patch("/subscriptions/" + record.id, {
          start_date: new_end_date,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
            if (response.data.refresh_required) {
              this.getDetailSubscription(record);
            }
          } else {
            console.log(response.data.data);
            $.notify(
              {
                // options
                message: "성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.getDetailSubscription(record);
          }
        });
    },
    set_end_date() {
      var record = this.Tsub;
      var new_end_date = prompt("새 종료일을 입력하세요. 예: 2022-04-05");
      if (!new_end_date) return;
      axios
        .patch("/subscriptions/" + record.id, {
          end_date: new_end_date,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
            if (response.data.refresh_required) {
              this.getDetailSubscription(record);
            }
          } else {
            console.log(response.data.data);
            $.notify(
              {
                // options
                message: "성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.getDetailSubscription(record);
          }
        });
    },
    set_pay_date() {
      var record = this.Tsub;
      var new_end_date = prompt("새 결제일을 입력하세요. 예: 2022-04-05");
      if (!new_end_date) return;
      axios
        .patch("/subscriptions/" + record.id, {
          pay_date: new_end_date,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
            if (response.data.refresh_required) {
              this.getDetailSubscription(record);
            }
          } else {
            console.log(response.data.data);
            $.notify(
              {
                // options
                message: "성공하였습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.getDetailSubscription(record);
          }
        });
    },
  },
  mounted() {
    this.Tsub = this.subscription;
  },
  watch: {
    sub() {
      alert("tsub has been updated");
      this.Tsub = this.subscription;
    },
  },
  props: {
    subscription: {
      type: Object,
      default: {},
    },
    btnId: String,
  },
  data() {
    return {
      TbtnId: this.btnId || Math.random().toString().substr(2, 5),
      Tsub: {},
      student: null,
      payUrl: "",
      active: false,
      pay_active: false,
      lastEnd: null,
      reload_once_closed: false,
    };
  },
};
</script>

<style></style>
